import { VApplication } from "../../../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { LandingPageService } from "../../../../../services";

const MODULE_NAME = "landingPage.machines.states.getPage";
const log: any = LoggerModule?.getInstance();

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.LandingPageService") as LandingPageService;
};

export const getPageBrands = async (context: any, event: any) => {
  const currentState = "GET_PAGE_CONTENT";
  const method = "getPageContent";

  return new Promise(async (resolve, reject) => {
    try {
      log.blue(MODULE_NAME, "context: ", context, "event: ", event);
      const srv = getSrv();
      const content = await srv.getBrandProfile();

      if (content) {
        return resolve({
          key: "GET_PAGE_CONTENT",
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = "Page content not found";
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: "RENDER_PAGE_ERROR",
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: "RENDER_PAGE_ERROR",
        value: err?.message,
      });
    }
  });
};
